import { format, parseISO } from 'date-fns';

/**
 * 作品の日付を号数の有無によってフォーマットする
 * @param date 日付
 * @param issueNumber 号数
 * @returns フォーマットされた日付
 *
 * @example
 * formatWorkDate('2025-01-01', 1) // '2025年1号'
 * formatWorkDate('2025-01-01', null) // '2025年1月1日'
 */
export const formatWorkDate = (date: string, issueNumber: number | null) => {
  if (issueNumber != null) {
    return `${date ? format(parseISO(date), 'yyyy') : ''}年${issueNumber}号`;
  }
  return `${date ? format(parseISO(date), 'yyyy年M月d日') : ''}`;
};
